module.exports = __webpack_public_path__ + "img/selected_tvcc.88ebbfc8.svg";